export default __webpack_public_path__ + "static/media/empties.5a8e2cd4.svg";